import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import secureLocalStorage from "react-secure-storage";
import { message } from "antd";
import SearchBar from "../../atoms/SearchBar";
import Hamburger from "../../atoms/Hamburger";

import UserProfile from "../../molecules/UserProfile";
import Breadcrumbs from "../../atoms/Breadcrumbs";
import { checkUserStatusThunk } from "../../../store/thunks/authThunk";
import { useDispatch } from "react-redux";

const Header = (props) => {
  const dispatch = useDispatch();
  const { nameLink } = props;
  const location = useLocation();

  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const checkUserStatus = async () => {
    const payload = {
      route: "users",
      action: "isLoggedIn",
      lIUId: slsLIUId,
    };

    await dispatch(checkUserStatusThunk(payload))
      .unwrap()
      .then((response) => {
        if (response === true) {
          secureLocalStorage.clear();
          window.location.href = process.env.REACT_APP_LOGIN_REDIRECT_URI;
        }
      })
      .catch((error) => {
        if (error.data && error.data.message) {
          message.error(error.data.message);
        }
      });
  };

  const searchBarPermissions = {
    "/auditForms": true,
    "/audits": true,
    "/deleted-audits": true,
    "/escalations/internal-error-rca": true,
    "/processes": true,
    "/departments": true,
    "/clients": true,
    "/users": true,
  };

  const isSearchVisible = searchBarPermissions[location.pathname] ?? false;

  useEffect(() => {
    if (slsToken) {
      // Run the function immediately
      checkUserStatus();

      const intervalId = setInterval(() => {
        checkUserStatus();
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [slsToken]);

  return (
    <div className="top-header">
      <Hamburger loc={location} />
      <Breadcrumbs loc={location} nameLink={nameLink} />
      <div className="searchProfile">
        {isSearchVisible && <SearchBar loc={location} nameLink={nameLink} />}
        <UserProfile
          slsToken={slsToken}
          slsLIUId={slsLIUId}
          slsRole={slsRole}
        />
      </div>
    </div>
  );
};

export default Header;
